import(/* webpackMode: "eager", webpackExports: ["GlobalProvider"] */ "/vercel/path0/src/providers/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.scss");
